import { render, staticRenderFns } from "./ImageSlider2.vue?vue&type=template&id=afdd5b9e"
import script from "./ImageSlider2.vue?vue&type=script&lang=ts"
export * from "./ImageSlider2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports